//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ThemePicker from '@/components/ThemePicker';
export default {
  components: {
    ThemePicker: ThemePicker
  },
  data: function data() {
    return {
      bg: "#ccc",
      navBarBg: "",
      topNavSetBg: "",
      topNavSetTextColor: "",
      topNavTextColor: "",
      leftNavBg: "",
      leftNavTextColor: "",
      leftNavSetBg: ""
    };
  },
  computed: {
    fixedHeader: {
      get: function get() {
        return this.$store.state.settings.fixedHeader;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: val
        });
      }
    },
    tagsView: {
      get: function get() {
        return this.$store.state.settings.tagsView;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'tagsView',
          value: val
        });
      }
    },
    sidebarLogo: {
      get: function get() {
        return this.$store.state.settings.sidebarLogo;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'sidebarLogo',
          value: val
        });
      }
    }
  },
  methods: {
    bgChange: function bgChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'bg',
        value: val
      });
    },
    topNavSetBgChange: function topNavSetBgChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'topNavSetBg',
        value: val
      });
    },
    navBarBgChange: function navBarBgChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'navBarBg',
        value: val
      });
    },
    topNavTextColorChange: function topNavTextColorChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'topNavTextColor',
        value: val
      });
    },
    topNavSetTextColorChange: function topNavSetTextColorChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'topNavSetTextColor',
        value: val
      });
    },
    leftNavBgColorChange: function leftNavBgColorChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'leftNavBg',
        value: val
      });
    },
    leftNavTextColorChange: function leftNavTextColorChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'leftNavTextColor',
        value: val
      });
    },
    leftNavSetBgChange: function leftNavSetBgChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'leftNavSetBg',
        value: val
      });
    },
    themeChange: function themeChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val
      });
    }
  }
};